.tooltip {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 14px;
    font-family: 'Averta', sans-serif;
    line-height: 20px;
    background-color: var(--ink);
}
